export enum PatientGoalNumberTypeEnum {
  VALUE = 'value',
  BETWEEN_VALUE = 'between_value',
}
